// Reusable loading spinner component with animated SVG

interface LoadingSpinnerProps {
  // Size of the spinner: 'sm' (h-3 w-3), 'md' (h-4 w-4), 'lg' (h-6 w-6)
  size?: "sm" | "md" | "lg";
  // Additional CSS classes to apply
  className?: string;
  // Aria label for accessibility
  ariaLabel?: string;
}

// Get size classes based on size prop
function getSizeClasses(size: "sm" | "md" | "lg"): string {
  const sizeMap = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-6 w-6",
  };
  return sizeMap[size];
}

// Loading spinner component - renders an animated SVG
export function LoadingSpinner({
  size = "md",
  className = "",
  ariaLabel = "Carregando",
}: LoadingSpinnerProps) {
  const sizeClasses = getSizeClasses(size);

  return (
    <svg
      className={`${sizeClasses} animate-spin ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-label={ariaLabel}
      aria-hidden={!ariaLabel}
    >
      {/* Background circle (lighter) */}
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      {/* Animated arc (darker) */}
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
